import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  selectedIngredients,
  selectedIngredientsFailed,
  selectedIngredientsSuccess,
} from './slice';
import * as endpoints from './endpoints';
import { searchItemsSuccess } from '../search/slice';

function* selectedIngredientsSaga({ payload }: ReturnType<typeof selectedIngredients>): any {
  const { mealType, ingredients, dishType } = payload;
  try {
    const response = yield call(
      request.get,
      `${endpoints.ingredientBasedRecipe}ingredients=${ingredients}&mealType=${mealType}&dishType=${dishType}&difficulty=moderate`
    );
    yield put(selectedIngredientsSuccess(response.data));
    yield put(searchItemsSuccess(response.data));
  } catch (error: any) {
    yield put(selectedIngredientsFailed(error));
  }
}

function* SelectIngredientsSagas() {
  yield all([takeLatest(selectedIngredients, selectedIngredientsSaga)]);
}
export { SelectIngredientsSagas };
